<h3 mat-dialog-title>{{ 'dialog.add_activity_to_pinboard_folder.title' | translate: {activityCount: data.activities.length} }}</h3>
<mat-dialog-content>
  @if (currentFolders.length === 0) {
    <span>{{ 'dialog.add_activity_to_pinboard_folder.no_pinboards' | translate }}</span>
  }
  @if (currentFolders.length === 1 && data.activities.length === 1 && !activityIsAlreadyOnFolder(data.activities[0], currentFolders[0].id)) {
    <span [innerHTML]="'dialog.add_activity_to_pinboard_folder.confirm' | translate: {folder: currentFolders[0].name}"></span>
  }
  @if (currentFolders.length === 1 && data.activities.length === 1 && activityIsAlreadyOnFolder(data.activities[0], currentFolders[0].id)) {
    <span [innerHTML]="'dialog.add_activity.to_pinboard_folder.already_in_folder' | translate: {folder: currentFolders[0].name}"></span>
  }
  @if (currentFolders.length === 1 && data.activities.length > 1) {
    <span [innerHTML]="'dialog.add_activity_to_pinboard_folder.confirm' | translate: {folder: currentFolders[0].name}"></span>
  }
  @if (currentFolders.length > 1) {
    @if (data.activities.length === 1) {
      <div class="activity">
        <div class="image-container">
          <app-doenkids-image [mediaItem]="{ uuid: data.activities[0].media_uuid , description: '' }"></app-doenkids-image>
        </div>
        <div class="text-container">
          <h2 class="activity-title">
            {{ data.activities[0].name !== '' ? data.activities[0].name : ('generic.new' | translate) }}
          </h2>
          <h3>
            {{ data.activities[0].subtitle }}
          </h3>
        </div>
      </div>
    }
    @if (data.activities.length > 1) {
      <div>
        <h2>{{ 'generic.activities' | translate }}</h2>
        @for (activity of data.activities; track activity) {
          <p>{{ activity.name }}</p>
        }
      </div>
    }
    <mat-form-field appearance="outline">
      <mat-label>{{ 'dialog.activity_to_pinboard_folder.select.label' | translate }}</mat-label>
      <mat-select [formControl]="selectedFolder" multiple>
        @for (folder of currentFolders; track folder) {
          <mat-option [value]="folder.id">
            {{ folder.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</mat-dialog-content>
<mat-dialog-actions class="flex-row justify-between" style="flex: 1 1 auto">
  <button mat-button color="primary" (click)="onClose()">{{ 'generic.close' | translate }}</button>
  <button
    mat-button color="primary"
    (click)="onAdd()"
    [disabled]="
      !selectedFolder.valid || currentFolders.length === 0
      || (
        currentFolders.length === 1
        && data.activities.length === 1
        && activityIsAlreadyOnFolder(data.activities[0], currentFolders[0].id)
      )
    "
    >
    {{ 'dialog.add_activity_to_pinboard_folder.add' | translate }}
  </button>
</mat-dialog-actions>
